import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import script from './verify-prompt.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"part":"wrapper","data-v-test-id":"verify-prompt-wrapper"}},[_c('magic-ui-step-progress-bar',{attrs:{"data-v-test-id":("step" + _vm.steps + "-progress"),"steps":_vm.steps,"current-step":_vm.steps}}),_vm._v(" "),(_vm.isSmsVerification)?_c('magic-corex-sms-verification',{attrs:{"data-v-test-id":"verify-prompt-sms-verification"},domProps:{"authModel":_vm.authModel}}):_c('magic-corex-email-verification',{attrs:{"data-v-test-id":"verify-prompt-email-verification","verification-email-clients":_vm.verificationEmailClients},domProps:{"model":_vm.authModel}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
